import {
  blueButton,
  darkModeBackgroundHoveredColor,
  darkModeLinkColor,
  darkModeTextColor,
} from "constants/colors";
import styled, { css } from "styled-components/macro";

export const MenuItemsWithTitleStyles = styled.div<{ $isDarkMode: boolean }>`
  ${({ $isDarkMode }) =>
    $isDarkMode
      ? css`
          color: ${darkModeTextColor};
        `
      : ""};
  display: flex;
  flex-direction: column;
  align-items: baseline;
  gap: 8px;
  padding-left: 16px;
  .MuiDivider-root {
    margin-top: 10px;
  }
  .sectionTitle {
    width: fit-content;
    font-size: 14px;
    padding: 6px 6px 6px 12px;
    background: ${({ $isDarkMode }) => ($isDarkMode ? "none" : "white")};
    margin-top: -14px;
    margin-left: -16px;
    font-style: italic;
  }
  li {
    width: 100%;
  }
`;
export const HighlightTagsSelectorStyles = styled.div<{
  $isDarkMode: boolean;
}>`
  position: relative;
  padding: 24px;
  transition: transform 0.5s cubic-bezier(0.165, 0.84, 0.44, 1);
  .highlightedTagsChips {
    display: flex;
    flex-direction: column;
    flex-wrap: wrap;
    max-height: 72px;
    align-content: flex-start;
    margin-left: -8px;
  }
  .btnTagHighlight {
    color: ${({ $isDarkMode }) =>
      $isDarkMode ? darkModeLinkColor : blueButton};
    height: 30px;
    margin-top: 6px;
    text-transform: none;
    padding: 6px 14px;
  }
`;
export const StyledColoredSquare = styled.div`
  box-sizing: border-box;
  width: 12px;
  height: 12px;
  border-radius: 50%;
  margin-right: 8px;
  margin-bottom: 2px;
`;
export const StyledColoredDiamond = styled.div`
  box-sizing: border-box;
  width: 12px;
  height: 12px;
  transform: rotate(45deg);
  margin-right: 8px;
  margin-bottom: 2px;
`;

export const HighlightedTagIndicatorStyles = styled.div<{
  $isDarkMode: boolean;
}>`
  display: flex;
  align-items: center;
  width: fit-content;
  height: 24px;
  padding-right: 6px;
  .highlighted-tag-text {
    max-width: 195px;
    flex-grow: 0;
    white-space: nowrap;
    width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
    font-size: 14px;
    padding: 5px 0;
    ${({ $isDarkMode }) =>
      $isDarkMode &&
      css`
        color: ${darkModeTextColor};
      `}
  }
  button.MuiIconButton-root {
    width: 19px;
    height: 24px;
    min-height: 0px !important;
  }
  .MuiSvgIcon-root {
    color: #9a9a9a;
    &:hover {
      color: #d61111;
      path {
        fill: #d61111;
      }
    }
    width: 19px;
    opacity: 0;
  }
  &:hover {
    background: ${({ $isDarkMode }) =>
      $isDarkMode ? darkModeBackgroundHoveredColor : "#f6f6f6"};
    .MuiSvgIcon-root {
      opacity: 1;
    }
  }
  .MuiButtonBase-root {
    padding: 0;
  }
  .colorIndicator {
    flex-shrink: 0;
    width: 6px;
    height: 14px;
    margin-right: 6px;
  }
`;
